<template>
  <v-container class="content">
    <!--loading screen when add video request is being handled-->
    <LoadingScreen :loading="loading" />

    <div class="nav" @click="goBack">
      <v-icon size="12px" color="#00457C">arrow_back_ios</v-icon> Back
    </div>
    <Dialog
      :title="'Are you sure you want to delete this item?'"
      :text="'This action is not reversible.'"
      :rejectButtonText="'No'"
      :acceptButtonText="'Yes'"
      :toggle="dialog"
      @reject="dialog = false"
      @accept="confirmDeleteItem"
    />
    <div class="header text-left">Manage News and Events Item</div>
    <v-row class="cover-photo">
      <v-col cols="12">
        <label for="cover-photo">Cover Photo</label>
      </v-col>
      <v-col cols="6" md="3">
        <input
          id="cover-photo"
          type="file"
          accept="image/x-png, image/jpeg"
          @change="(e) => setImage(e.target.files[0])"
        />
        <input type="text" readonly v-model="imageFileName" />
      </v-col>
      <v-col cols="6" md="3">
        <label for="cover-photo" id="browse-btn">Browse</label>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <label for="title">Title</label>
        <input id="title" type="text" v-model="title" />
        <div class="error-msg" v-show="$v.title.$invalid">
          This is a required field.
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <label for="content">Content</label>
        <textarea id="content" type="text" v-model="content" />
        <div class="error-msg" v-show="$v.content.$invalid">
          This is a required field.
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="3">
        <label for="URL">URL</label>
        <input id="URL" type="text" v-model="url" />
        <div class="error-msg" v-show="$v.url.$invalid">
          Please enter a URL in the following format: http://www.example.com/.
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="3">
        <label for="sequence">Sequence</label>
        <input id="sequence" type="text" v-model="sequence" />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6" md="3">
        <v-btn
          color="#00457C"
          :disabled="$v.$invalid"
          @click="submitNewsEventsForm"
          >Save Changes</v-btn
        >
      </v-col>
      <v-col cols="6" md="3">
        <v-btn color="#EA6254" @click="deleteNewsItem">Delete</v-btn>
      </v-col>
    </v-row>
    <v-row v-if="success">
      <v-col cols="12">
        <v-alert type="success"
          >News and events item updated successfully.</v-alert
        >
      </v-col>
    </v-row>
    <v-row v-if="error">
      <v-col cols="12">
        <v-alert type="error">Error occurred. Please try again.</v-alert>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";
import Dialog from "./commons/Dialog";
import { required, url } from "vuelidate/lib/validators";
import LoadingScreen from "./commons/LoadingScreen";

export default {
  components: {
    Dialog,
    LoadingScreen,
  },

  data() {
    return {
      title: "",
      content: "",
      url: "",
      imageFile: null,
      selectedId: this.$route.params.itemId,
      dialog: false,
      imageUrl: null,
      imageFileName: null,
      loading: false,
      success: false,
      error: false,
      sequence: "",
    };
  },

  //rules for validation
  validations: {
    title: {
      required,
    },
    content: {
      required,
    },
    url: {
      required,
      url,
    },
    imageFileName: {
      required,
    },
  },

  mounted() {
    axios
      .get(
        process.env.VUE_APP_HOST_SERVER + "/api/news-events/" + this.selectedId
      )
      .then((res) => this.processFetchedData(res.data))
      .catch((err) => console.log(err));
  },

  methods: {
    goBack() {
      this.$router.push({ name: "HomepageNewsEvents" }).catch(() => {});
    },

    processFetchedData(rawData) {
      this.title = rawData.message.title;
      this.content = rawData.message.desc;
      this.url = rawData.message.url;
      this.imageUrl = rawData.message.imageUrl;
      this.imageFileName = rawData.message.imageUrl.slice(82);
      this.sequence = rawData.sequence;
    },

    setImage(file) {
      if (file !== null) {
        // Set image file
        this.imageFile = file;
        this.imageFileName = file.name;
      }
    },

    submitNewsEventsForm() {
      this.loading = true; //enable loading screen once user clicks submit

      if (this.imageFile) {
        const NewsEventsFormData = new FormData();
        NewsEventsFormData.append("imageFile", this.imageFile);
        // Upload image to AWS
        axios
          .post(
            process.env.VUE_APP_HOST_SERVER + "/api/image_upload/news-events",
            NewsEventsFormData,
            { headers: { "Content-Type": "multipart/form-data" } }
          )
          .then((res) => {
            console.log(
              "Successfully uploaded news & events image ",
              res.data.imageUrl
            );

            this.imageUrl = res.data.imageUrl;
            const newsEventsDetails = {
              title: this.title,
              desc: this.content,
              url: this.url,
              imageUrl: this.imageUrl,
              id: this.selectedId,
              sequence: this.sequence,
            };

            axios
              .post(
                process.env.VUE_APP_HOST_SERVER + "/api/news-events/save",
                newsEventsDetails
              )
              .then(() => {
                this.loading = false;
                this.success = true;
                this.error = false;
              });
          })
          .catch((err) => {
            console.log(err);
            this.loading = false;
            this.error = true;
          });
      } else {
        const newsEventsDetails = {
          title: this.title,
          desc: this.content,
          url: this.url,
          imageUrl: this.imageUrl,
          id: this.selectedId,
          sequence: this.sequence,
        };

        axios
          .post(
            process.env.VUE_APP_HOST_SERVER + "/api/news-events/save",
            newsEventsDetails
          )
          .then(() => {
            this.loading = false; //disable loading screen once request is handled
            this.success = true; //show success message
            this.error = false;
          })
          .catch((err) => {
            console.log(err);
            this.error = true;
          });
      }
    },

    deleteNewsItem() {
      this.dialog = true;
    },

    confirmDeleteItem() {
      this.dialog = false;
      this.loading = true;

      axios
        .post(process.env.VUE_APP_HOST_SERVER + "/api/news-events/delete", {
          id: this.selectedId,
        })
        .then(() => {
          console.log("Successfully deleted item from DB");
          axios
            .delete(process.env.VUE_APP_HOST_SERVER + "/api/file/delete", {
              data: {
                s3Url: this.imageUrl,
              },
            })
            .then(() => {
              this.loading = false;
              this.goBack();
              this.error = false;
            });
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
          this.error = true;
        });
    },
  },
};
</script>

<style scoped>
.content {
  box-shadow: 0px 1px 20px rgba(163, 163, 163, 0.25);
  border: 1px solid #eeeeee;
  padding: 25px;
  text-align: initial;
}

.content .row {
  padding-bottom: 18px;
}

.content .row:nth-last-child(1) {
  padding-bottom: 0;
}

.content .nav {
  color: #00457c;
  font-weight: bold;
  padding-bottom: 16px;
  border-bottom: 1px solid #efefef;
  margin-bottom: 25px;
  font-size: 16px;
  cursor: pointer;
  width: 100%;
}

.content .header {
  font-size: 26px;
  margin-bottom: 20px;
  font-weight: normal;
}

.content button {
  width: 100%;
  font-size: 14px;
  font-weight: normal;
  color: white;
  text-transform: none;
  letter-spacing: normal;
}

label {
  font-size: 14px;
  color: #6f6f6f;
  margin-bottom: 10px;
  display: block;
}

.cover-photo div:first-child {
  padding-bottom: 0;
}

.cover-photo div:nth-child(2),
.cover-photo div:nth-child(3) {
  padding-top: 0;
}

#cover-photo {
  display: none;
}

label#browse-btn {
  display: inline-block;
  background: #ffffff;
  box-shadow: 0px 1px 5px rgba(120, 120, 120, 0.25);
  border-radius: 5px;
  color: #9b9b9b;
  padding: 10px;
  margin-bottom: 0;
}

input[type="text"] {
  padding: 10px;
  box-sizing: border-box;
  border: 1px solid #dfdfdf;
  border-radius: 5px;
  width: 100%;
  font-size: 14px;
}

.error-msg {
  font-size: 10px;
  color: #ea6254;
  margin-top: 5px;
}

textarea {
  padding: 10px;
  box-sizing: border-box;
  border: 1px solid #dfdfdf;
  border-radius: 5px;
  width: 100%;
  font-size: 14px;
}
</style>
